/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import { NodeRecordTypeMap } from '../../backendModels/records.model';
import { InputState } from '../../backendModels/general.model';
import { NumericFieldValue } from '../../backendModels/generic-element.model';

export const QSOFA_RECORD_ELEMENT_KEY = 'qSofa';

export type QSOFARecord = NodeRecordTypeMap['generic'] &
  (
    | {
        readonly elementKey: typeof QSOFA_RECORD_ELEMENT_KEY;
        readonly inputState: InputState.ENTERED;
        readonly values: {
          qSofaScore: NumericFieldValue;
        };
      }
    | {
        readonly inputState: InputState.UNKNOWN;
        readonly values: null;
      }
  );
